class StickyProductBar extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.init();
      this.listenEvents();
      this.updateState();
    });
  }

  init() {
    this.nativeSubmitButtons = document.querySelector('.product__submit__buttons');
    this.buyButton = this.querySelector(".product-bar__button");
    this.comparePrice = this.querySelector("[data-product-price-old]");
    this.price = this.querySelector("[data-product-price]");
    this.firstOption = this.querySelector("[data-product-first-option] span");
    this.splitPrice = this.querySelector("[data-product-split-price]");
    this.productPopups = document.querySelectorAll('product-popup');
  }

  // On phones the bar waits until the page is scrolled this far, and still hides while the page's own button is on screen
  static MOBILE_SHOW_AFTER = 1000;

  listenEvents() {
    this.nativeInView = true;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.nativeInView = entry.isIntersecting;
          requestAnimationFrame(() => this.syncActive());
        });
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
      }
    );
    window.addEventListener("scroll", () => {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.syncActive();
      });
    }, { passive: true });
    this.observer.observe(this.nativeSubmitButtons);
    document.addEventListener("change:variant", (e) => {
      this.updateState(e.detail.variant);
    });
    // The page's own button runs the add; its loading and added states are mirrored here
    const submit = this.nativeSubmitButtons.querySelector('button[type="submit"]');
    if (submit) {
      new MutationObserver(() => {
        this.buyButton.classList.toggle('is-loading', submit.classList.contains('is-loading'));
        this.buyButton.classList.toggle('is-added', submit.classList.contains('is-added'));
      }).observe(submit, { attributes: true, attributeFilter: ['class'] });
    }
    this.buyButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      let submitButton = this.nativeSubmitButtons.querySelector('button[type="submit"]')
      let notifyButton = this.nativeSubmitButtons.querySelector('button[type="button"]')
      if (!submitButton.disabled) {
        submitButton.click();
        this.closePopups();
      } else if (notifyButton) {
        notifyButton.click();
        this.closePopups();
      }
    })
  }

  syncActive() {
    const farEnough = !window.theme.isMobile() || window.scrollY > StickyProductBar.MOBILE_SHOW_AFTER;
    this.classList.toggle("active", !this.nativeInView && farEnough);
  }

  updateState(variant) {
    if (variant) {
      this.comparePrice.innerHTML = variant.compare_at_price;
      // Personal discount: the struck price is the regular price the discount comes off
      const personalDiscount = window.theme.hasCustomerDiscount(variant.price, variant.compare_at_price);
      if (personalDiscount) {
        this.price.classList.add("--sale");
        this.comparePrice.innerHTML = window.theme.formatMoney(variant.price, theme.moneyFormat);
      } else if (variant.compare_at_price > variant.price) {
        this.price.classList.add("--sale");
        this.comparePrice.innerHTML = window.theme.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        );
      } else {
        this.price.classList.remove("--sale");
        this.comparePrice.innerHTML = "";
      }
      this.price.innerHTML = window.theme.formatMoney(
        window.theme.customerPrice(variant.price, variant.compare_at_price),
        theme.moneyFormat
      );
      this.firstOption.innerHTML = variant.option1;

      let oldSplitPrice = this.splitPrice.dataset.productSplitPrice;
      let newSplitPrice = String(window.theme.formatMoney(window.theme.customerPrice(variant.price, variant.compare_at_price) / 4, theme.moneyFormat));
      let spanElement = this.splitPrice.querySelector("span");
      spanElement.innerHTML = spanElement.innerHTML.replace(oldSplitPrice, newSplitPrice);

      let isAvailable = variant.available;
      if (isAvailable) {
        this.buyButton.querySelector('.add-to-cart-text').classList.remove('hide');
        this.buyButton.querySelector('.sold-out-text').classList.add('hide');
      } else {
        this.buyButton.querySelector('.add-to-cart-text').classList.add('hide');
        this.buyButton.querySelector('.sold-out-text').classList.remove('hide');
      }

    } else {
      const defaultPrice = Number(this.price.dataset.defaultPrice);
      const defaultCompare = Number(this.comparePrice.dataset.defaultPrice);
      if (window.theme.hasCustomerDiscount(defaultPrice, defaultCompare)) {
        this.price.classList.add("--sale");
        this.comparePrice.innerHTML = window.theme.formatMoney(
          this.price.dataset.defaultPrice,
          theme.moneyFormat
        );
      } else if (
        this.comparePrice.dataset.defaultPrice > this.price.dataset.defaultPrice
      ) {
        this.price.classList.add("--sale");
        this.comparePrice.innerHTML = window.theme.formatMoney(
          this.comparePrice.dataset.defaultPrice,
          theme.moneyFormat
        );
      }

      this.price.innerHTML = window.theme.formatMoney(
        window.theme.customerPrice(defaultPrice, defaultCompare),
        theme.moneyFormat
      );

      let oldSplitPrice = this.splitPrice.dataset.productSplitPrice;
      let newSplitPrice = String(window.theme.formatMoney(window.theme.customerPrice(defaultPrice, defaultCompare) / 4, theme.moneyFormat));
      let spanElement = this.splitPrice.querySelector("span");
      spanElement.innerHTML = spanElement.innerHTML.replace(oldSplitPrice, newSplitPrice);
      this.splitPrice.dataset.productSplitPrice = newSplitPrice;
    }
  }
  closePopups() {
    this.productPopups.forEach((popup) => {
      popup.popupClose();
    });
  }
}

if (!customElements.get("sticky-product-bar")) {
  customElements.define("sticky-product-bar", StickyProductBar);
}
